module.exports = __webpack_public_path__ + "img/BLCA_CD8Tex.7f313fda.png";